import { PaymentList } from './PaymentList'

export { PaymentList }


// WEBPACK FOOTER //
// ./src/components/payment/index.js